import {
  calculatorSlugs,
  querySlugs,
  standaloneScopeLabels,
} from "../../../constants/calculatorApiTypes";

// Catálogo de escopos da calculator-api (`recurso:ação`), um por produto,
// agrupado por família para o seletor. Montado a partir dos slugs que a tela
// conhece: o catálogo do calculator-api cresce sem aviso, então um escopo fora
// daqui é normal e precisa sobreviver ao PATCH (ver `unknownScopes`).
const INDICES_SCOPE = "calculadoras.indices-correcao:read";
const JUS_SCORE_SCOPE = "jus-score:execute";

// `key` é fixo e sem espaço: vira `key` de lista e `id` de elemento no seletor.
const familyFromSlugs = (key, label, labelBySlug, scopeOf) => ({
  key,
  label,
  scopes: Object.entries(labelBySlug).map(([slug, productLabel]) => ({
    scope: scopeOf(slug),
    label: productLabel,
  })),
});

const standaloneFamily = (key, label, scope) => ({
  key,
  label,
  scopes: [{ scope, label: standaloneScopeLabels[scope] }],
});

export const SCOPE_FAMILIES = [
  familyFromSlugs(
    "calculators",
    "Calculadoras",
    calculatorSlugs,
    slug => `calculadoras.${slug}:execute`,
  ),
  standaloneFamily("correction-indices", "Índices de correção", INDICES_SCOPE),
  familyFromSlugs(
    "queries",
    "Consultas",
    querySlugs,
    slug => `consultas.${slug}:execute`,
  ),
  standaloneFamily("jus-score", "JusScore", JUS_SCORE_SCOPE),
];

const labelByScope = new Map(
  SCOPE_FAMILIES.flatMap(family =>
    family.scopes.map(({ scope, label }) => [scope, label]),
  ),
);

// escopo desconhecido aparece cru
export const scopeLabel = scope => labelByScope.get(scope) ?? scope;

export const unknownScopes = scopes =>
  scopes.filter(scope => !labelByScope.has(scope));

// O que sai da lista ao salvar: o cliente perde o acesso na requisição seguinte.
export const removedScopes = (previousScopes, nextScopes) =>
  previousScopes.filter(scope => !nextScopes.includes(scope));

// Marca ou desmarca um conjunto de escopos sem tocar no resto da lista — é o
// que preserva os desconhecidos, já que o PATCH substitui a lista inteira.
export const toggleScopes = (selectedScopes, scopesToToggle, checked) =>
  checked
    ? [
        ...selectedScopes,
        ...scopesToToggle.filter(scope => !selectedScopes.includes(scope)),
      ]
    : selectedScopes.filter(scope => !scopesToToggle.includes(scope));
